import { defineMessages } from 'react-intl'

const scope = `procurify.components.DateCell`

export default defineMessages({
  overdueLabel: {
    id: `${scope}.overdueLabel`,
    defaultMessage: 'Overdue',
  },
})
